



















import { Component, Vue } from "vue-property-decorator";
import axios, { AxiosResponse } from "axios";
import { ia_agent, ia_agents_store } from "@/shared/classes/ia_agents_store";
import chat_header from "@/components/chat/chat_header.vue";
import messages_list from "@/components/chat/messages_list.vue";
import message_input from "@/components/chat/message_input.vue";
import { UtilsString } from "@/utils/utils-string";
import { EventBus } from "@/shared/services/event-bus-simple";
import { chat_message } from "@/shared/classes/chat_message";
import { chat_history_item } from "@/shared/classes/chat_history_item";
import { chat_history_service } from "@/store/modules/chat-history";
import { UserCache } from "@/store/modules/user-cached-work";
import { default_agent, ia_agents_mock } from "@/store/modules/ia_agents_mock";

@Component({
  components: {
    chat_header,
    messages_list,
    message_input,
  },
})
export default class chat extends Vue {
  // estado principal
  public draft: string = "";
  public isLoading: boolean = false;
  public messages: chat_message[] = [];
  //public chat: chat_history_item | null = null;
  public sidebarOpen: boolean = true;

  public isEditingProfile: boolean = false;
  public userName: string = "";
  public experienceLevel: string = "Bajo";

  // historial de chats
  public chatHistory: chat_history_item[] = [];
  public currentChatId: string | null = null;
  public id_chat_to_load: string | null = null;

  // prompt base
  private baseSystemPrompt: string = "";
  public mounted(): void {
    let id = this.$route.meta.id;
    if (id === undefined) {
      id = this.$route.params.id;
    }
    this.loadUserFromCache();
    this.loadChatHistory();
    try {
      this.applyAgentToChat(this.Ia_agent_store!);
    } catch (e) {}
    if (this.userName.length !== 0) {
      if (!UtilsString.IsNullOrWhiteSpace(id)) {
        this.id_chat_to_load = String(id);
        this.loadChat(id);
      } else {
        this.initializeNewChat();
      }
    }
  }

  // Handlers de hijos
  public onSendFromChild(text: string): void {
    this.draft = text;
    this.send();
  }

  public get Ia_agent_store(): ia_agent /*| null*/ {
    if (!this.$route.query || !this.$route.query.data) {
      console.log(
        "No hay query data",
        this.$route,
        this.chatHistory.find((c) => c.id === this.currentChatId)
      );
      const agentId = this.chatHistory.find((c) => c.id === this.currentChatId)!
        .id_agent!;
      const agent = ia_agents_store.get(agentId);
      if (agent) {
        console.log("Agente del chat", agent);
        return agent;
      }
    }

    if (this.$route.query && this.$route.query.data) {
      try {
        const agentId = String(this.$route.query.data).replace(/"/g, "");
        const agent = ia_agents_store.get(agentId);
        console.log(agent);
        if (agent) {
          return agent;
        }
      } catch (e) {}
    }
    return default_agent;
  }

  public get titulo_chat(): string {
    if (this.currentChatId) {
      const chat = this.chatHistory.find((c) => c.id === this.currentChatId);
      if (chat) {
        return chat.title;
      }
    }
    return "Nuevo chat";
  }

  // === Lógica original (sin cambios estructurales) ===
  private getSystemPrompt(): string {
    this.baseSystemPrompt = this.Ia_agent_store.systemPrompt;
    return (
      this.baseSystemPrompt +
      "\n\nCondiciones adicionales obligatorias:\n\n" +
      "— Dirígete siempre al usuario por su nombre: " +
      this.userName +
      ".\n" +
      "— Ajusta el nivel de experiencia en la explicación a: " +
      this.experienceLevel +
      " (usa lenguaje accesible y ejemplos simples)."
    );
  }

  private initializeNewChat(): void {
    const systemPrompt: string = this.getSystemPrompt();
    const initialPhrase =
      this.Ia_agent_store.empezar &&
      this.Ia_agent_store.empezar.trim().length > 0
        ? this.Ia_agent_store.empezar
        : ", ¿puedes describir tu idea de negocio en una frase?";
    const initialMessages: chat_message[] = [
      { role: "system", content: systemPrompt },
      {
        role: "assistant",
        content: this.userName+", "+ initialPhrase,
      },
    ];
    this.messages = initialMessages;
    this.currentChatId = null;
  }
  public loadChat(chatId: string): void {
    const chat = this.chatHistory.find(function(c) {
      return c.id === chatId;
    })!;
    if (chat) {
      this.messages = chat.messages.slice(0);
      this.currentChatId = chatId;
      this.draft = "";
    }
  }

  private ensureChatInHistory(): void {
    if (!this.currentChatId) {
      const newId = Date.now().toString();
      const firstUser = this.messages.find(function(m) {
        return m.role === "user";
      });
      const titleBase =
        firstUser && typeof firstUser.content === "string"
          ? firstUser.content.substring(0, 50) +
            (firstUser.content.length > 50 ? "..." : "")
          : "Nueva conversación";

      const item: chat_history_item = {
        id: newId,
        title: titleBase,
        id_agent: this.Ia_agent_store ? this.Ia_agent_store.id : null,
        timestamp: Date.now(),
        messages: this.messages.slice(0),
      };
      this.chatHistory.unshift(item);
      this.saveChatHistory();
      this.currentChatId = newId;
      EventBus.$emit("newchatStarted", newId);
    }
  }

  private updateCurrentChat(newMessages: chat_message[]): void {
    if (!this.currentChatId) return;
    const chatIndex = this.chatHistory.findIndex(
      (c) => c.id === this.currentChatId
    );
    if (chatIndex > -1) {
      const firstUser = newMessages.find(function(m) {
        return m.role === "user";
      });
      var title = this.chatHistory[chatIndex].title;
      if (firstUser && typeof firstUser.content === "string") {
        const slice = firstUser.content.substring(0, 50);
        title = slice + (firstUser.content.length > 50 ? "..." : "");
      }

      this.chatHistory[chatIndex] = {
        id: this.chatHistory[chatIndex].id,
        title: title,
        id_agent: this.Ia_agent_store ? this.Ia_agent_store.id : null,
        timestamp: Date.now(),
        messages: newMessages,
      };
      this.saveChatHistory();
    }
  }

  private loadUserFromCache(): void {
    try {
      var user = UserCache.load();
      if (user != null) {
        this.userName = user.name;
        this.experienceLevel = user.experienceLevel;
      }
    } catch (e) {}
  }

  private loadChatHistory(): void {
    try {
      this.chatHistory = chat_history_service.readAll();
    } catch (e) {}
  }

  private saveChatHistory(): void {
    try {
      chat_history_service.writeAll(this.chatHistory);
    } catch (e) {}
  }

  // Aplicar un agente al chat actual:
  public applyAgentToChat(agent: ia_agent): void {
    // Reemplaza el SystemPrompt base y reinicia el chat inicial (sin guardar hasta que el usuario hable)
    this.baseSystemPrompt = agent.systemPrompt;
    this.initializeNewChat();
  }

  public async send(): Promise<void> {
    if (this.draft.trim().length === 0 || this.isLoading) return;

    const userMessage: chat_message = { role: "user", content: this.draft };
    this.messages.push(userMessage);

    this.ensureChatInHistory();

    const payload = this.buildPayload(this.messages);
    this.draft = "";
    this.isLoading = true;

    try {
      const response: AxiosResponse<any> = await axios.post(
        "https://public-api.devexpress.com/demo-openai/openai/deployments/gpt-4o-mini/chat/completions?api-version=2024-02-01",
        payload,
        {
          headers: {
            "api-key": "DEMO",
            accept: "application/json",
            "content-type": "application/json",
          },
        }
      );

      var content: string = "";
      const data = response && response.data ? response.data : null;
      const choices = data && data.choices ? data.choices : null;
      if (choices && choices.length > 0) {
        const msg =
          choices[0] && choices[0].message ? choices[0].message : null;
        content = msg && typeof msg.content === "string" ? msg.content : "";
      }
      if (content.length === 0) {
        content =
          this.userName +
          ", la respuesta llegó vacía. Prueba a reformular el mensaje.";
      }

      this.messages.push({ role: "assistant", content: content });
      this.updateCurrentChat(this.messages);
    } catch (error) {
      const err: any = error;
      const msg = err && err.message ? err.message : "Error desconocido";
      this.messages.push({
        role: "assistant",
        content: this.userName + ", no se pudo completar la solicitud: " + msg,
      });
      this.updateCurrentChat(this.messages);
    } finally {
      this.isLoading = false;
    }
  }

  private buildPayload(history: chat_message[]): any {
    return {
      messages: history.map(function(m) {
        return { role: m.role, content: m.content };
      }),
      model: "gpt-4o-mini",
      max_tokens: 1000,
      temperature: 0.7,
    };
  }
}
